import { render, staticRenderFns } from "./LoginComponent.vue?vue&type=template&id=5c86c53a"
import script from "./LoginComponent.vue?vue&type=script&lang=js"
export * from "./LoginComponent.vue?vue&type=script&lang=js"
import style0 from "./LoginComponent.vue?vue&type=style&index=0&id=5c86c53a&prod&lang=css"
import style1 from "./LoginComponent.vue?vue&type=style&index=1&id=5c86c53a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports